import { Skeleton } from "@mui/material";
import React from "react";

const TransactionFeedSkeleton = () => {
  return (
    <div>
      <div className="overflow-x-auto bg-white shadow-md rounded-lg border border-gray-200">
        <table className="w-full text-sm text-left text-gray-700 min-w-[600px]">
          <thead className="text-xs text-gray-500 uppercase bg-gray-50 border-b">
            <tr>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Payment ID</th>
              <th className="px-4 py-3">Amount</th>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 1 }).map((_, index) => (
              <tr key={index} className="border-b">
                <td className="px-4 py-3">
                  <Skeleton width={100} height={20} />
                  <Skeleton width={80} height={14} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton width={120} height={20} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton width={60} height={20} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton width={100} height={20} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton variant="rounded" width={60} height={24} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionFeedSkeleton;
